"use strict";
import inside from "point-in-polygon";
import AnnotationComponents from "./components";
import DragPoint from "./drag_point";
export function isPointIn(p, polygon) {
  const point = [p.x, p.y];
  return inside(point, polygon);
}
export const hoverFor = (mousePos) => (typeID, dragPoints) => {
  const Comp = AnnotationComponents[typeID];
  const hoveredDragPointIndex = dragPoints.findIndex(
    DragPoint.isPointIn(mousePos)
  );
  const isIndex = typeof hoveredDragPointIndex === "number" && hoveredDragPointIndex >= 0;
  return {
    hovered: isPointIn(mousePos, Comp.getBoundingBox(dragPoints)) || isIndex,
    dragPointIndex: isIndex ? hoveredDragPointIndex : false
  };
};
